<template>
  <base-section
    id="customer-reviews"
    class="grey lighten-5"
    space="64"
  >
    <base-section-heading
      icon="mdi-chat-processing"
      space="0"
      title="Unsere Kunden sagen.."
    />

    <v-carousel
      class="mt-n12"
      height="600"
      light
    >
      <v-carousel-item
        v-for="(customer, i) in customers"
        :key="i"
      >
        <v-container class="fill-height">
          <v-responsive
            class="mx-auto shrink text-center"
            max-width="90%"
            width="700"
          >
            <base-title
              :title="customer.title"
              space="0"
            />
            <base-body
              :text="customer.review"
              tag="em"
              class="mb-6 d-block"
            />

            <!-- <v-avatar
              class="mb-6"
              size="128"
            >
              <base-img :src="require(`@/assets/user-${i + 1}.jpg`)" />
            </v-avatar> -->

            <!-- <base-subtitle :title="customer.role" /> -->
          </v-responsive>
        </v-container>
      </v-carousel-item>
    </v-carousel>
  </base-section>
</template>

<script>
  export default {
    name: 'SectionCustomerReviews',

    provide: {
      heading: { align: 'center' },
    },

    data: () => ({
      customers: [
        {
          review: '"Bar mit kleinem aber feinem Restaurant. Das Tagesmenü war sehr lecker. Cooles, gemütliches Ambiente. Sehr empfehlenswert."',
          title: 'Super Ambiente – Leckeres Essen',
        },
        {
          review: '"Sowohl das gute Essen als auch die angenehme Atmosphäre haben mich überzeugt."',
          title: 'Ein Lokal mit dem gewissen Etwas',
        },
        {
          review: '"Sehr freundliche Bedienung. Gute regionale Küche mit abwechslungsreichen Gerichten."',
          title: 'Top Service',
        },
        {
          review: '"Ich hatte mir nicht erwartet ein so einladendes Lokal in einem Bürokomplex vorzufinden. Sehr guter Kaffee – leckeres Essen – gemütliche Atmosphäre – freundlicher Service."',
          title: 'Sehr einladendes Ambiente ',
        },
      ],
    }),
  }
</script>

<style lang="sass">
  #customer-reviews
    .v-carousel__controls
      background: transparent

    .base-body
      line-height: 2
</style>
